import React, { createContext, useContext, useState } from 'react';
import './Alert.css';

const AlertContext = createContext();

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within AlertProvider');
  }
  return context;
};

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type = 'info') => {
    setAlert({ message, type });
    
    // Auto-dismiss after 4 seconds
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  const hideAlert = () => {
    setAlert(null);
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {alert && (
        <div className="alert-overlay" onClick={hideAlert}>
          <div className={`alert alert-${alert.type}`} onClick={(e) => e.stopPropagation()}>
            <div className="alert-content">
              <span className="alert-icon">
                {alert.type === 'success' && '✓'}
                {alert.type === 'error' && '✕'}
                {alert.type === 'warning' && '⚠'}
                {alert.type === 'info' && 'ℹ'}
              </span>
              <span className="alert-message">{alert.message}</span>
            </div>
            <button className="alert-close" onClick={hideAlert}>×</button>
          </div>
        </div>
      )}
    </AlertContext.Provider>
  );
};

